 
// import React, { useState } from "react";
// import { Typography, Card, Button, Input, Skeleton } from "antd";
// import { useNavigate } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
// import toast from "react-hot-toast";
// import { motion } from "framer-motion";
// import {
//   CarOutlined,
//   FileTextOutlined,
//   SafetyCertificateOutlined,
//   ArrowLeftOutlined,
// } from "@ant-design/icons";
// import RCCWithChallanCard from "../components/RCCWithChallanCard";
// import { backend_url } from "../LOCAL/VARIABLE";

// const { Title, Paragraph } = Typography;

// // ✅ Backend se fetch karna
// const fetchRCDetails = async (rcNumber) => {
//   const res = await fetch(`${backend_url}/api/rc/rcwithchallan/${rcNumber}`); // apna backend endpoint
//   if (!res.ok) {

//   const errorData = await res.json().catch(() => ({
//         message: "Something went wrong!",
//       }));

//       // Toast dikhao
//       toast.error(errorData.message || "Failed to fetch RC details");
//        // Error throw karo taki upar handle kar sako
//       throw new Error(errorData.message || "Failed to fetch RC details");
//   }
//   const ss= await res.json();
//   return ss
// };

 



// const renderObject = (data) => {
 
// };



// const RCFetch = () => {
//   const navigate = useNavigate();
//   const [rcNumber, setRCNumber] = useState("");
//   const [submittedRC, setSubmittedRC] = useState("");

//   const { data: rcData, isFetching , isLoading } = useQuery({
//     queryKey: ["rcDetails", submittedRC],
//     queryFn: () => fetchRCDetails(submittedRC),
//     enabled: !!submittedRC,
//     refetchOnWindowFocus: false,
//     retry: false,
//     onError: (d) => toast.error( d.response.data.message ||  "Failed to fetch RC details"),
//     onSuccess: () => toast.success("RC details fetched successfully"),
//   });

//   const handleFetchRC = () => {
//     if (!rcNumber) return toast.error("Please enter RC number");
//     setSubmittedRC(rcNumber);
//   };

//   return (
//     <div className="flex flex-col h-screen bg-gray-100">
//       {/* Header */}
//       <header className="flex items-center px-4 py-3 bg-white text-black shadow-md fixed w-full z-50 h-[55px]">
//         <Button
//           type="text"
//           icon={<ArrowLeftOutlined style={{ fontSize: 20, color: "red" }} />}
//           onClick={() => navigate(-1)}
//         />
//         <Title level={5} className="m-0 flex-1 text-center !text-red-600">
//           Fetch RC Details With Challan
//         </Title>
//       </header>

//       {/* Content */}
//       <div className="mt-[55px] flex-1 overflow-y-auto   pb-8">
//         {/* RC Input */}
//         <section className="mb-4">
//           <Input
//             placeholder="Enter RC Number"
//             value={rcNumber}
//             onChange={(e) => setRCNumber(e.target.value)}
//             className="mb-2"
//           />
//           <Button type="primary" loading={isLoading} className="bg-red-500" block onClick={handleFetchRC}>
//             Fetch RC & Challan Details
//           </Button>
//         </section>

//         {/* RC Details */}
//         <section>
//           {isFetching ? (
//             <Skeleton active paragraph={{ rows: 12 }} />
//           ) : (
//             rcData && (
             
//                 <RCCWithChallanCard data={rcData}/>
               
//             )
//           )}
//         </section>

      
//       </div>
//     </div>
//   );
// };

// export default RCFetch;



import React, { useState } from "react";
import { Typography, Card, Button, Input, Skeleton } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { ArrowLeftOutlined } from "@ant-design/icons";
import RCCWithChallanCard from "../components/RCCWithChallanCard";
import { backend_url } from "../LOCAL/VARIABLE";

const { Title } = Typography;

// Fetch RC with Challan details
const fetchRCDetails = async (rcNumber,user) => {
  const res = await fetch(`${backend_url}/api/rc/rcwithchallan/${rcNumber}?user=${user}`);
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({
      message: "Something went wrong!",
    }));

    toast.error(errorData.message || "Failed to fetch RC details");
    throw new Error(errorData.message || "Failed to fetch RC details");
  }
  
  return await res.json();
};

const RCFetch = () => {
  const navigate = useNavigate();
  const [rcNumber, setRCNumber] = useState("");
  const [submittedRC, setSubmittedRC] = useState("");
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const user = queryParams.get("user");


  const { data: rcData, isFetching, isLoading } = useQuery({
    queryKey: ["rcDetails", submittedRC],
    queryFn: () => fetchRCDetails(submittedRC ,user  ),
    enabled: !!submittedRC,
    refetchOnWindowFocus: false,
    retry: false,
    onError: (error) => toast.error(error.message || "Failed to fetch RC details"),
    onSuccess: (data) => {
      if (data.data.code === "1006") {
        toast.success("No challan found for this vehicle");
      } else if (data.data.code === "1005") {
        toast.success("Challan details fetched successfully");
      }
    },
  });

  const handleFetchRC = () => {
    if (!rcNumber.trim()) {
      return toast.error("Please enter RC number");
    }
    setSubmittedRC(rcNumber);
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* Header */}
      <header className="flex items-center px-4 py-3 bg-white text-black shadow-md fixed w-full z-50 h-[55px]">
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 20, color: "red" }} />}
          onClick={() => navigate(-1)}
        />
        <Title level={5} className="m-0 flex-1 text-center !text-red-600">
          Fetch RC Challan Details
        </Title>
      </header>

      {/* Content */}
      <div className="mt-[55px] flex-1 overflow-y-auto pb-8 p-1">
        {/* RC Input Section */}
        <Card className="mb-4 shadow-sm">
          <div className="mb-4">
            <Input
              placeholder="Enter RC Number (e.g., DL01AB1234)"
              value={rcNumber}
              onChange={(e) => setRCNumber(e.target.value)}
              size="large"
              onPressEnter={handleFetchRC}
            />
          </div>
          <Button 
            type="primary" 
            loading={isLoading} 
            className="bg-red-500 hover:bg-red-600" 
            block 
            onClick={handleFetchRC}
            size="large"
          >
            {isLoading ? "Fetching..." : "Fetch Challan Details"}
          </Button>
        </Card>

        {/* Results Section */}
        {isFetching ? (
          <Card>
            <Skeleton active paragraph={{ rows: 8 }} />
          </Card>
        ) : (
          rcData && (
            <div>
              {rcData.data.code === "1006" ? (
                <Card className="text-center py-8">
                  <div className="text-green-500 text-5xl mb-4">✓</div>
                  <Title level={4} className="text-green-600">
                    No Challan Found
                  </Title>
                  <p className="text-gray-600">
                    No pending challans found for vehicle {submittedRC}
                  </p>
                </Card>
              ) : (
                <RCCWithChallanCard data={rcData} />
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default RCFetch;